var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title__container",class:_vm.enter && 'title__container--enter'},[_c('h1',[_vm._v(_vm._s(_vm.$store.state.titlePrj))])])
}
var staticRenderFns = []

export { render, staticRenderFns }